<template>
  <el-form-item :label="label" size="small">
    <el-switch :value="value" @input="$emit('input', $event)"></el-switch>
  </el-form-item>
</template>

<script>
export default {
  name: 'app-type-switch',
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    field: {
      type: String
    },
    rules: {
      type: [ Object, Array ]
    },
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>
